import axios from "axios";
import IpLocationResponse from "api/model/IpLocationResponse";

export const getLocation = (): Promise<IpLocationResponse> => axios.get<IpLocationResponse>('/api/locations/ip', {timeout: 3000}).then(res => res.data);